import { FreeFortuneFormData } from "features/無料占いBot/hooks/useFreeFortuneForm";
import { useRouter } from "next/router";
import qs from "qs";
import useLocalStorage from "shared/hooks/useLocalStorage";
import { Paths } from "utils/routes";

const cookieOptions = {
  maxAge: 30 * 24 * 60 * 60,
  path: "/",
};

interface SubmitAction {
  [key: string]: (data?: FreeFortuneFormData) => void;
}

interface UseSubmitActionsReturn {
  dispatchSubmitAction: (data: FreeFortuneFormData) => void;
  cookieOptions: {
    maxAge: number;
    path: string;
  };
}

const useSubmitActions = (): UseSubmitActionsReturn => {
  const { push, query } = useRouter();
  const { setItemAsString, keys } = useLocalStorage();

  const submitActions: SubmitAction = {
    default: async () => {
      await push({
        pathname: query.isSubscription
          ? Paths.subscription.plans(query.id).無料占い結果
          : Paths.無料占い結果(),
        query,
      });
    },
    line: async (data: FreeFortuneFormData) => {
      const queries = qs.stringify({
        ...query,
        free_fortune_chat_question_id: data.answer,
      });
      push(`line://app/${process.env.NEXT_PUBLIC_LIFF_ID}?${queries}`);
    },
  };

  const dispatchSubmitAction = async (data: FreeFortuneFormData) => {
    setItemAsString(keys["free_fortune/data"], data);

    if (typeof query.action !== "string") {
      submitActions.default();
    }

    const submitAction = query.action as string;
    const action = submitActions[submitAction];
    action ? await action(data) : submitActions.default();
  };

  return { dispatchSubmitAction, cookieOptions };
};

export default useSubmitActions;
